import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBathasuComponent } from './simple-icons-bathasu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBathasuComponent ],
    exports:      [ SimpleIconsBathasuComponent ],
    bootstrap:    []
})
export class SimpleIconsBathasuModule {}
